module.exports = __webpack_public_path__ + "static/LifeFlight-12e6dc68e6c8bf735e48f80b45edc359.gif";